import { call, put, take, select, takeLatest } from "redux-saga/effects";
import { httpDelete, httpGet, httpPost, httpPut } from "../../services";
import { showLoadingAction } from "../actions/appStateActions";
import {
  AddMobileAppsSchema,
  addMobileAppsSottErrorAction,
  addMobileAppsSottLoadingAction,
  addMobileAppsSottSuccessAction,
  addWebAppsErrorAction,
  addWebAppsLoadingAction,
  addWebAppsSuccessAction,
  CustomDomainConst,
  CustomDomainSchema,
  CustomRegistrationField,
  DeploymentConst,
  getCustomDomainErrorAction,
  getCustomDomainLoadingAction,
  getCustomDomainSuccessAction,
  getCustomFieldAction,
  getCustomFieldErrorAction,
  getCustomFieldLoadingAction,
  getCustomFieldSuccessAction,
  getMobileAppsSottErrorAction,
  getMobileAppsSottLoadingAction,
  getMobileAppsSottSuccessAction,
  getPlatformFieldErrorAction,
  getPlatformFieldLoadingAction,
  getPlatformSuccessAction,
  getRegistrationFieldErrorAction,
  getRegistrationFieldLoadingAction,
  getRegistrationFieldSuccessAction,
  getWebAppsErrorAction,
  getWebAppsLoadingAction,
  getWebAppsSuccessAction,
  JSWidgetsConst,
  MobileAppsConst,
  MobileAppsSchema,
  postPlatformFieldErrorAction,
  postPlatformFieldLoadingAction,
  postPlatformSuccessAction,
  saveJSWidgetsOptionalCaptchaErrorAction,
  saveJSWidgetsOptionalCaptchaLoadingAction,
  saveJSWidgetsOptionalCaptchaSuccessAction,
  // SMTPSettingsConst,
  updatePropsDataSchemaSuccessAction,
  // VerifySMTPSettingResponseSchema,
  // VerifySMTPSettingSchema,
  // verifySMTPSettingsErrorAction,
  // verifySMTPSettingsLoadingAction,
  // verifySMTPSettingsSuccessAction,
  WebAppsConst,
  WebAppsSchema,
  SaveCustomDomainArgs,
  DeleteCustomDomainArgs,
  deleteCustomDomainSuccessAction,
  deleteCustomDomainErrorAction,
  DeleteCustomDomainSchema,
  deleteCustomDomainLoadingAction,
  saveCustomDomainSuccessAction,
  saveCustomDomainErrorAction,
  SaveCustomDomainSchema,
  saveCustomDomainLoadingAction,
  getAllEmailTemplatesAction,
  getAllEmailTemplatesLoadingAction,
  getAllEmailTemplatesSuccessAction,
  getAllEmailTemplatesErrorAction,
  createEmailTemplateLoadingAction,
  createEmailTemplateSuccessAction,
  createEmailTemplateErrorAction,
  updateEmailTemplateLoadingAction,
  updateEmailTemplateSuccessAction,
  updateEmailTemplateErrorAction,
  deleteEmailTemplateLoadingAction,
  deleteEmailTemplateSuccessAction,
  deleteEmailTemplateErrorAction,
  resetEmailTemplateLoadingAction,
  resetEmailTemplateSuccessAction,
  resetEmailTemplateErrorAction,
  setDefaultEmailTemplateLoadingAction,
  setDefaultEmailTemplateSuccessAction,
  setDefaultEmailTemplateErrorAction,
  getEmailSettingsAction,
  getEmailSettingsLoadingAction,
  getEmailSettingsSuccessAction,
  getEmailSettingsErrorAction,
  saveEmailSettingsLoadingAction,
  saveEmailSettingsSuccessAction,
  saveEmailSettingsErrorAction,
  // sendTestEmailLoadingAction,
  // sendTestEmailSuccessAction,
  // sendTestEmailErrorAction,
  generateEmailTemplateAILoadingAction,
  generateEmailTemplateAISuccessAction,
  generateEmailTemplateAIErrorAction
} from "../actions/deploymentActions";
import { ActionSchema } from "../actions";
import { getOptionalCaptchaApisSuccessAction } from "../actions/platformConfigurationActions";
import {
  deleteProgressiveProfilingDataFailure,
  deleteProgressiveProfilingDataRequest,
  deleteProgressiveProfilingDataSuccess,
  getProgressiveProfilingDataFailure,
  getProgressiveProfilingDataRequest,
  getProgressiveProfilingDataSuccess,
  updateProgressiveProfilingDataFailure,
  updateProgressiveProfilingDataRequest,
  updateProgressiveProfilingDataSuccess
} from "../features/branding/progressiveProfiling";
import { getCustomFieldLimitFailure, getCustomFieldLimitRequest, getCustomFieldLimitSuccess } from "../features/branding/customFieldLimit";
import {
  addCustomFieldError,
  addCustomFieldRequest,
  addCustomFieldSuccess,
  deleteCustomFieldError,
  deleteCustomFieldRequest,
  deleteCustomFieldSuccess
} from "../features/branding/customFieldMutations";
import { getCustomFieldsAction as refreshProfileCustomFields } from "../actions/customerManagementActions";
import { RootSchema } from "../reducers";

import {
  getSMTPSettingsAction,
  getSMTPSettingsSuccess,
  getSMTPSettingsError,
  updateSMTPSettingsAction,
  updateSMTPSettingsSuccess,
  updateSMTPSettingsError,
  addSMTPSettingsAction,
  addSMTPSettingsSuccess,
  addSMTPSettingsError,
  deleteSMTPSettingsAction,
  deleteSMTPSettingsSuccess,
  deleteSMTPSettingsError,
  setDefaultSMTPSettingsAction,
  setDefaultSMTPSettingsSuccess,
  setDefaultSMTPSettingsError
} from "../features/branding/smtpSettings";

/*
 * Web apps Handler
 */
function filterSites(Urls, WebAppsData) {
  Urls.forEach(function (element) {
    element = element.trim();
    let found = false;
    for (let i = 0; i < WebAppsData.length; i++) {
      if (WebAppsData[i].url === element) {
        found = true;
      }
    }
    if (!found) {
      WebAppsData.push({ url: element });
    }
  });

  return WebAppsData;
}
function appendSites(data) {
  const prodSites: string[] = [],
    stagSites: string[] = [];
  data.production &&
    data.production.map((item) => {
      if (item.url) {
        prodSites.push(item.url);
      }
    });
  data.staging &&
    data.staging.map((item) => {
      if (item.url) {
        stagSites.push(item.url);
      }
    });
  return {
    domain: prodSites[0],
    production: prodSites.join(";"),
    staging: stagSites.join(";")
  };
}
function* getwebAppsHandler(payload: any) {
  //const WebAppsData = { production: [], staging: [] };
  try {
    //  yield put(showLoadingAction(true, "Please Wait..."));
    yield put(getWebAppsLoadingAction());
    let ownerUid = "";
    if (payload.data) {
      ownerUid = payload.data;
    }
    const webApps: WebAppsSchema = yield httpGet("/deployment/sites", {
      ownerUid
    });
    if (webApps.errorCode) {
      throw new Error(webApps.message || "");
    }
    if (webApps.CallbackUrl) {
      const WepAppsList = webApps.CallbackUrl.split(";");
      webApps.production = filterSites(WepAppsList, []);
    }
    if (webApps.DevDomain) {
      const devDomainList = webApps.DevDomain.split(";");
      if (webApps.production && webApps.production.length) {
        webApps.production = filterSites(devDomainList, webApps.production);
      } else {
        webApps.production = filterSites(devDomainList, []);
      }
    }
    yield put(getWebAppsSuccessAction(webApps));
  } catch (e: any) {
    yield put(getWebAppsErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}
function* addWebAppsHandler(payload: any) {
  const jsonData = appendSites(payload);
  try {
    //  yield put(showLoadingAction(true, "Please Wait..."));
    yield put(addWebAppsLoadingAction());
    const data: WebAppsSchema = yield httpPost("/deployment/sites", {}, jsonData);
    if (data.errorCode) {
      const Deployment = (state) => state.deployment;
      const _deployment = yield select(Deployment);
      if (_deployment.webApps.CallbackUrl) {
        const WepAppsList = _deployment.webApps.CallbackUrl.split(";");
        _deployment.webApps.production = filterSites(WepAppsList, "production");
      }
      if (_deployment.webApps.DevDomain) {
        const devDomainList = _deployment.webApps.DevDomain.split(";");
        _deployment.webApps.production = filterSites(devDomainList, "production");
      }

      const msg = data.message || "error";
      yield put(addWebAppsErrorAction(msg));
      yield put(getWebAppsSuccessAction(_deployment.webApps));
    } else {
      if (data.CallbackUrl) {
        const WepAppsList = data.CallbackUrl.split(";");
        data.production = filterSites(WepAppsList, []);
      }
      if (data.DevDomain) {
        const devDomainList = data.DevDomain.split(";");
        if (data.production && data.production.length) {
          data.production = filterSites(devDomainList, data.production);
        } else {
          data.production = filterSites(devDomainList, []);
        }
      }
      yield put(addWebAppsSuccessAction(data));
    }
  } catch (e: any) {
    yield put(addWebAppsErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}

//Optional Captcha
function* saveJSWidgetsOptionalCaptcha({ payload }) {
  try {
    yield put(saveJSWidgetsOptionalCaptchaLoadingAction());
    const data = yield httpPut("/platform-configuration/advance/optional-captcha", {}, payload);
    yield put(saveJSWidgetsOptionalCaptchaSuccessAction(data));
    yield put(getOptionalCaptchaApisSuccessAction(payload));
    yield;
  } catch (e: any) {
    yield put(saveJSWidgetsOptionalCaptchaErrorAction(e.message));
  }
}
//Custom Field
function* getCustomFieldHandler() {
  try {
    yield put(getCustomFieldLoadingAction());
    const data = yield httpGet("/platform-configuration/custom-fields", {});
    if (data.errorCode || data.StatusCode) {
      if (data.errorCode !== 1047) {
        throw new Error(data.message || "");
      } else {
        data.Data = [];
      }
    }
    yield put(getCustomFieldSuccessAction(data));
  } catch (e: any) {
    yield put(getCustomFieldErrorAction(e.message));
  }
}
export function* watchGetCustomField() {
  while (true) {
    yield take(CustomRegistrationField.GET_CUSTOM_FIELD);
    yield call(getCustomFieldHandler);
  }
}
// Registration Field
function* getRegistrationFieldHandler() {
  try {
    yield put(getRegistrationFieldLoadingAction());
    const data = yield httpGet("/platform-configuration/registration-form-settings", {});
    if (data.errorCode || data.StatusCode) {
      throw new Error(data.message || "");
    }
    yield put(getRegistrationFieldSuccessAction(data));
  } catch (e: any) {
    yield put(getRegistrationFieldErrorAction(e.message));
  }
}
// Post Platform Field
//postPlatformFieldAction,
function* postPlatformFieldHandler(dataField: any) {
  try {
    yield put(postPlatformFieldLoadingAction());
    const Data = yield httpPost("/platform-configuration/default-fields", { d: Date.now() }, dataField);
    if (Data.errorCode || Data.StatusCode) {
      throw new Error(Data.message || "");
    }
    yield put(postPlatformSuccessAction(Data));
  } catch (e: any) {
    yield put(postPlatformFieldErrorAction(e.message));
  }
}
// Platform Field
function* getPlatformFieldHandler() {
  try {
    yield put(getPlatformFieldLoadingAction());
    const data = yield httpGet("/platform-configuration/platform-registration-fields", {});
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(getPlatformSuccessAction(data));
  } catch (e: any) {
    yield put(getPlatformFieldErrorAction(e.message));
  }
}
export function* watchPostPlatformField() {
  while (true) {
    const data = yield take(CustomRegistrationField.POST_PLATFORM_FIELD);
    yield call(postPlatformFieldHandler, data.payload);
  }
}
export function* watchGetPlatformField() {
  while (true) {
    yield take(CustomRegistrationField.GET_PLATFORM_FIELD);
    yield call(getPlatformFieldHandler);
  }
}
export function* watchGetRegistrationField() {
  while (true) {
    yield take(CustomRegistrationField.GET_REGISTRATION_FORMS_FIELD);
    yield call(getRegistrationFieldHandler);
  }
}

//-----------------------------------------
export function* watchGetWebApps() {
  while (true) {
    const data = yield take(WebAppsConst.GET_WEB_APPS);
    yield call(getwebAppsHandler, data.payload);
  }
}

export function* watchAddWebApps() {
  while (true) {
    const data = yield take(WebAppsConst.ADD_WEB_APPS);

    yield call(addWebAppsHandler, data.payload);
  }
}

/*
 * Custom Domain Handler
 */

function* getCustomDomainHandler() {
  try {
    yield put(getCustomDomainLoadingAction());
    const data: CustomDomainSchema = yield httpGet("/deployment/customdomain/bindingrequest");
    if (data.ErrorCode) {
      throw new Error(data.Description || "Unable to retrieve custom domain information. Please try again.");
    }
    yield put(getCustomDomainSuccessAction(data));
  } catch (e: any) {
    yield put(getCustomDomainErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}
export function* watchGetCustomDomain() {
  while (true) {
    yield take(CustomDomainConst.GET_CUSTOM_DOMAIN);
    yield call(getCustomDomainHandler);
  }
}

function* saveCustomDomainHandler({ payload }: SaveCustomDomainArgs) {
  try {
    yield put(saveCustomDomainLoadingAction());
    const response: SaveCustomDomainSchema = yield httpPost("/deployment/customdomain/bindingrequest", {}, payload);
    if (response.ErrorCode) {
      if (response.ErrorCode === 1109) {
        throw new Error("Custom domain exists. Please use a different name.");
      }
      throw new Error(response.Description || response.Message);
    }
    yield put(saveCustomDomainSuccessAction(response));
  } catch (e: any) {
    yield put(saveCustomDomainErrorAction(e.message));
  }
}

function* deleteCustomDomainHandler({ payload }: DeleteCustomDomainArgs) {
  try {
    yield put(deleteCustomDomainLoadingAction());
    const response: DeleteCustomDomainSchema = yield httpDelete("/deployment/customdomain/bindingrequest", {}, payload);
    if (response.ErrorCode) {
      throw new Error(response.Description || response.Message);
    }
    yield put(deleteCustomDomainSuccessAction(response));
  } catch (e: any) {
    yield put(deleteCustomDomainErrorAction(e.message));
  }
}

export function* watchSaveCustomDomain() {
  while (true) {
    const { payload }: ActionSchema<SaveCustomDomainArgs> = yield take(CustomDomainConst.SAVE_CUSTOM_DOMAIN);
    yield call(saveCustomDomainHandler, payload);
  }
}

export function* watchDeleteCustomDomain() {
  while (true) {
    const { payload }: ActionSchema<DeleteCustomDomainArgs> = yield take(CustomDomainConst.DELETE_CUSTOM_DOMAIN);
    yield call(deleteCustomDomainHandler, payload);
  }
}
//Mobile Apps Sott
function* getMobileAppsSottHandler() {
  try {
    // yield put(showLoadingAction(true, "Please Wait..."));
    yield put(getMobileAppsSottLoadingAction());
    const data: MobileAppsSchema = yield httpGet("/deployment/sott");
    if (data.errorCode) {
      if (data.errorCode === 997) {
        yield put(getMobileAppsSottSuccessAction({ Data: [] }));
      } else {
        throw new Error(data.message);
      }
    } else {
      yield put(getMobileAppsSottSuccessAction(data));
    }
  } catch (e: any) {
    yield put(getMobileAppsSottErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}
export function* watchGetMobileAppsSott() {
  while (true) {
    yield take(MobileAppsConst.GET_MOBILE_APPS_SOTT);
    yield call(getMobileAppsSottHandler);
  }
}
// function* verifySMTPSettingsHandler(settings: VerifySMTPSettingSchema, i18n: LanguageSchema) {
//   try {
//     yield put(verifySMTPSettingsLoadingAction());
//     const data: VerifySMTPSettingResponseSchema = yield httpPost("/deployment/smtp-settings/verifysmtpsettings", {}, settings);
//     if (data.ErrorCode !== undefined) {
//       let error = "";
//       if (data.ErrorCode === 1027) {
//         const LEARN_MORE_AT = i18n.LEARN_MORE_AT;
//         if (data.Description) {
//           if (data.Description.indexOf(LEARN_MORE_AT) !== -1) {
//             error = data.Description.replace(LEARN_MORE_AT, "");
//           } else if (data.Description.indexOf(i18n.SPECIFIC_STRING_NOT_VALID_FORM_FOR_EMAIL_ADDRESS) !== -1) {
//             error = i18n.EMAIL_CANNOT_BE_SENT_CHECK_EMAIL_CONFIGURATION;
//           } else {
//             error = data.Description;
//           }
//         }
//       } else {
//         error = data.Description || data.Message || "";
//       }
//       throw Error(error);
//     }
//     yield put(verifySMTPSettingsSuccessAction(data));
//   } catch (e: any) {
//     yield put(verifySMTPSettingsErrorAction(e.message));
//   }
// }

function* addMobileAppsSottHandler(sdata) {
  try {
    yield put(addMobileAppsSottLoadingAction());
    const data: AddMobileAppsSchema = yield httpPost("/deployment/sott", {}, { ...sdata });
    if (data.errorCode === 1189) {
      throw Error(data.description || data.message);
    }
    yield put(addMobileAppsSottSuccessAction(data));
  } catch (e: any) {
    yield put(addMobileAppsSottErrorAction(e.message));
  } finally {
    yield put(showLoadingAction(false));
  }
}

function* updateDataSchemaHandler(platFormFields, registrationDataFields, customFilesds) {
  yield put(updatePropsDataSchemaSuccessAction(platFormFields, registrationDataFields, customFilesds));
}
export function* watchUpdateDataSchema() {
  while (true) {
    const { payload } = yield take(CustomRegistrationField.UPDATE_DATASCHEMA_FIELDS_DATA);
    yield call(updateDataSchemaHandler, payload.platFormFields, payload.registrationDataFields, payload.customFilesds);
  }
}

function* getProgressiveProfilingHandler() {
  try {
    const response = yield httpGet("/deployment/progressive-profile", { d: Date.now() });

    if (response.ErrorCode) {
      throw new Error(response.Message || response.Description || "Unable to get available integrations.");
    }

    yield put(getProgressiveProfilingDataSuccess(response));
  } catch (e: any) {
    yield put(getProgressiveProfilingDataFailure(e.message));
  }
}
export function* watchGetProgressiveProfiling() {
  yield takeLatest(getProgressiveProfilingDataRequest.type, getProgressiveProfilingHandler);
}

function* getCustomFieldLimitHandler() {
  try {
    const response = yield httpGet("/platform-configuration/custom-fields-limit", {});

    if (response?.ErrorCode) {
      throw new Error(response.Message || response.Description || "Unable to get the custom field limit.");
    }

    yield put(getCustomFieldLimitSuccess(response));
  } catch (e: any) {
    yield put(getCustomFieldLimitFailure(e.message));
  }
}
export function* watchGetCustomFieldLimit() {
  yield takeLatest(getCustomFieldLimitRequest.type, getCustomFieldLimitHandler);
}

// Creating or deleting a custom field reaches every form at once, so every path owes the same two
// refreshes: this screen's list (getCustomFieldAction), and the tenant-wide customerManagement
// list that Manage Users search-by, the profile editor, and the segmentation and orchestration
// query builders read. Those screens only fetch when their slice is empty, so a missed refresh
// leaves the field invisible to them until a full page reload.
//
// This is not the only path, so do not read it as the single source of truth. The /branding/forms
// Custom Fields section goes through these handlers; the builder still calls the same two
// endpoints directly from inside an open form — TableEditor/AddCustomField for create,
// useCustomFieldCrud for delete — each dispatching its own copy of the two refreshes. Owning them
// here settles it for this path and is the shape the other two take when they move over; it does
// nothing about the copies while they exist, and those have already diverged on user-visible copy
// (CUSTOM_FIELD_ADDED / CUSTOM_FIELD_REMOVED here against CUSTOM_FIELD_ADDED_TOAST /
// CUSTOM_FIELD_DELETED_TOAST there — different strings for the same event). See the note at the
// top of containers/Branding/Forms/CustomFields for the split and why it stands for now.
function* refreshCustomFieldConsumers() {
  yield put(getCustomFieldAction());
  yield put(refreshProfileCustomFields());
}

function* addCustomFieldHandler(action) {
  const i18n = yield select((state: RootSchema) => state.appState.i18n.languages);
  try {
    const response = yield httpPost("/platform-configuration/custom-field", { d: Date.now() }, action.payload);

    // The endpoint answers 200 with the failure nested inside responseAddCustomField, so both
    // error paths are shape checks rather than a rejected promise.
    if (!response?.responseAddCustomField) {
      throw new Error(response?.Message || i18n.SOMETHING_WENT_WRONG_WHILE_LOADING_PLEASE_TRY_AGAIN);
    }
    if (response.responseAddCustomField.ErrorCode) {
      throw new Error(response.responseAddCustomField.Description);
    }

    yield put(addCustomFieldSuccess({ message: i18n.CUSTOM_FIELD_ADDED }));
    yield call(refreshCustomFieldConsumers);
  } catch (e: any) {
    yield put(addCustomFieldError(e?.Description || e?.Message || e?.message || i18n.SOMETHING_WENT_WRONG_WHILE_LOADING_PLEASE_TRY_AGAIN));
  }
}
export function* watchAddCustomField() {
  yield takeLatest(addCustomFieldRequest.type, addCustomFieldHandler);
}

function* deleteCustomFieldHandler(action) {
  const i18n = yield select((state: RootSchema) => state.appState.i18n.languages);
  try {
    const response = yield httpDelete("/platform-configuration/custom-field", { d: Date.now() }, action.payload);

    if (!response?.IsDeleted) {
      throw new Error(response?.Description || response?.Message || i18n.SOMETHING_WENT_WRONG_WHILE_LOADING_PLEASE_TRY_AGAIN);
    }

    yield put(deleteCustomFieldSuccess({ message: i18n.CUSTOM_FIELD_REMOVED }));
    yield call(refreshCustomFieldConsumers);
  } catch (e: any) {
    yield put(deleteCustomFieldError(e?.Description || e?.Message || e?.message || i18n.SOMETHING_WENT_WRONG_WHILE_LOADING_PLEASE_TRY_AGAIN));
  }
}
export function* watchDeleteCustomField() {
  yield takeLatest(deleteCustomFieldRequest.type, deleteCustomFieldHandler);
}

function* updateProgressiveProfilingHandler(action) {
  try {
    const response = yield httpPut("/deployment/progressive-profile", {}, action.payload);

    if (response.ErrorCode) {
      throw new Error(response.Message || response.Description || "Something went wrong.");
    }

    yield put(updateProgressiveProfilingDataSuccess({ ...response, requestedStep: action.payload.Step }));
  } catch (e: any) {
    yield put(updateProgressiveProfilingDataFailure(e.message));
  }
}
export function* watchUpdateProgressiveProfiling() {
  yield takeLatest(updateProgressiveProfilingDataRequest.type, updateProgressiveProfilingHandler);
}

function* deleteProgressiveProfilingHandler(action) {
  try {
    const response = yield httpDelete("/deployment/progressive-profile", action.payload, {});

    if (response.ErrorCode || !response.IsDeleted) {
      throw new Error(response.Message || response.Description || "Something went wrong.");
    }

    yield put(deleteProgressiveProfilingDataSuccess(action.payload));
  } catch (e: any) {
    yield put(deleteProgressiveProfilingDataFailure(e.message));
  }
}

function* getSMTPSettingsHandler() {
  try {
    const data = yield httpGet("/deployment/smtp-settings/config");
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(getSMTPSettingsSuccess(data));
  } catch (e) {
    yield put(getSMTPSettingsError(e.message));
  }
}

function* addSMTPSettingsHandler(payload) {
  try {
    const data = yield httpPost("/deployment/smtp-settings", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(addSMTPSettingsSuccess(data));
  } catch (e) {
    yield put(addSMTPSettingsError(e.message));
  }
}

function* updateSMTPSettingsHandler(payload) {
  try {
    const data = yield httpPut("/deployment/smtp-settings", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(updateSMTPSettingsSuccess(data));
  } catch (e) {
    yield put(updateSMTPSettingsError(e.message));
  }
}

function* deleteSMTPSettingsHandler(payload: any) {
  try {
    const data = yield httpDelete("/deployment/smtp-settings", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(deleteSMTPSettingsSuccess(payload.payload));
  } catch (e) {
    yield put(deleteSMTPSettingsError(e.message));
  }
}

function* setDefaultSMTPSettingsHandler(payload: any) {
  try {
    const data = yield httpPost("/deployment/smtp-settings/default", {}, payload.payload);
    if (data.ErrorCode) {
      throw new Error(data.Message);
    }
    yield put(setDefaultSMTPSettingsSuccess(payload.payload.emailConfigId));
  } catch (e) {
    yield put(setDefaultSMTPSettingsError(e.message));
  }
}

export function* watchSMTPSettings() {
  yield takeLatest(getSMTPSettingsAction.type, getSMTPSettingsHandler);
  yield takeLatest(addSMTPSettingsAction.type, addSMTPSettingsHandler);
  yield takeLatest(updateSMTPSettingsAction.type, updateSMTPSettingsHandler);
  yield takeLatest(deleteSMTPSettingsAction.type, deleteSMTPSettingsHandler);
  yield takeLatest(setDefaultSMTPSettingsAction.type, setDefaultSMTPSettingsHandler);
}

export function* watchDeleteProgressiveProfiling() {
  yield takeLatest(deleteProgressiveProfilingDataRequest.type, deleteProgressiveProfilingHandler);
}
export function* watchAddMobileAppSott() {
  while (true) {
    const { payload } = yield take(MobileAppsConst.ADD_MOBILE_APPS_SOTT);
    yield call(addMobileAppsSottHandler, { ...payload });
  }
}
export function* watchJSWidgetOptionalCaptcha() {
  while (true) {
    const data = yield take(JSWidgetsConst.UPDATE_OPTIONAL_CAPTCHA);
    yield call(saveJSWidgetsOptionalCaptcha, { ...data });
  }
}

// Email Template Handlers
function* getAllEmailTemplatesHandler() {
  try {
    yield put(getAllEmailTemplatesLoadingAction());

    let data = yield httpGet("/deployment/email-workflow");
    if (data.ErrorCode) {
      // 1028: no data / 7922: no templates configured yet (fresh app). Both are expected
      // empty states, not errors — fall back to defaults instead of surfacing a toast.
      if (data.ErrorCode === 1028 || data.ErrorCode === 7922) {
        data = { Data: [] };
      } else {
        throw new Error(data.Message || data.Description);
      }
    }

    yield put(
      getAllEmailTemplatesSuccessAction({
        ...data
      })
    );
  } catch (e) {
    yield put(getAllEmailTemplatesErrorAction(e.message));
  }
}

const buildTemplatePayload = (template: any, isDefault?: boolean) => ({
  ...template,
  name: isDefault ? "" : template.TemplateName?.trim?.(),
  body: template.Template,
  subject: template.Subject,
  templatetype: template.TemplateType,
  fromemail: template.FromEmail,
  fromname: template.FromName
});

function* createEmailTemplateHandler(template: any) {
  try {
    yield put(createEmailTemplateLoadingAction());
    const payload = buildTemplatePayload(template, template.isLrTemplate);
    const data = yield httpPost("/deployment/email-workflow", {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(createEmailTemplateSuccessAction({ ...data }));
    yield put(getAllEmailTemplatesAction());
  } catch (e) {
    yield put(createEmailTemplateErrorAction(e.message));
  }
}

function* updateEmailTemplateHandler(template: any) {
  try {
    yield put(updateEmailTemplateLoadingAction());
    const payload = { ...buildTemplatePayload(template, template.isLrTemplate), isDefault: !!template.IsDefault };
    const data = yield httpPut("/deployment/email-workflow", {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(updateEmailTemplateSuccessAction({ ...data }));
    yield put(getAllEmailTemplatesAction());
  } catch (e) {
    yield put(updateEmailTemplateErrorAction(e.message));
  }
}

function* resetEmailTemplateHandler(template: any) {
  try {
    yield put(resetEmailTemplateLoadingAction());
    const payload = { ...buildTemplatePayload(template, false), isDefault: !!template.IsDefault };
    const data = yield httpPut("/deployment/email-workflow", {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(resetEmailTemplateSuccessAction({ ...data }));
    yield put(getAllEmailTemplatesAction());
  } catch (e) {
    yield put(resetEmailTemplateErrorAction(e.message));
  }
}

function* deleteEmailTemplateHandler(templateType: string, templateName: string) {
  try {
    yield put(deleteEmailTemplateLoadingAction());
    const data = yield httpDelete("/deployment/email-workflow", {}, { templatetype: templateType, id: templateName });
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(deleteEmailTemplateSuccessAction({ ...data }));
    yield put(getAllEmailTemplatesAction());
  } catch (e) {
    yield put(deleteEmailTemplateErrorAction(e.message));
  }
}

function* getEmailSettingsHandler() {
  try {
    yield put(getEmailSettingsLoadingAction());
    const data = yield httpGet("/deployment/email-workflow/email-settings", {});
    // 7920: email settings not found / 7922: no templates configured yet (fresh app).
    // Both are expected empty states for a new app, not errors to surface as a toast.
    if (data.ErrorCode && data.ErrorCode !== 7920 && data.ErrorCode !== 7922) {
      throw new Error(data.ErrorMessage || data.message || data.Message || "");
    }
    yield put(getEmailSettingsSuccessAction({ ...data }));
  } catch (e) {
    yield put(getEmailSettingsErrorAction(e.message));
  }
}

function* saveEmailSettingsHandler(settingsPayload: any) {
  try {
    const { settings, templateUpdate } = settingsPayload;
    yield put(saveEmailSettingsLoadingAction());
    const data = yield httpPost("/deployment/email-workflow/email-settings", {}, { Data: [settings] });
    if (data.ErrorCode || data.errorCode) {
      throw new Error(data.ErrorMessage || data.message || data.Message || "");
    }
    if (templateUpdate) {
      yield httpPut("/deployment/email-workflow", {}, templateUpdate);
    }
    yield put(saveEmailSettingsSuccessAction({ ...data }));
    yield put(getEmailSettingsAction());
    yield put(getAllEmailTemplatesAction());
  } catch (e) {
    yield put(saveEmailSettingsErrorAction(e.message));
  }
}

// function* sendTestEmailHandler(mailObject: any) {
//   try {
//     yield put(sendTestEmailLoadingAction());
//     const data = yield httpPost("/deployment/smtp-settings/default-test-email", {}, mailObject);
//     if (data.ErrorCode) {
//       throw new Error(data.Message || data.Description);
//     }
//     yield put(sendTestEmailSuccessAction({ ...data }));
//   } catch (e) {
//     yield put(sendTestEmailErrorAction(e.message));
//   }
// }

function* generateEmailTemplateAIHandler(payload: any) {
  try {
    yield put(generateEmailTemplateAILoadingAction());
    const data = yield httpPost("/deployment/email-workflow/ai", {}, payload);
    if (!data.emailHtmlCode || !data.subjectLine || data.errorCode) {
      throw new Error(data.message || "AI generation failed, try again later");
    }
    yield put(generateEmailTemplateAISuccessAction({ ...data }));
  } catch (e) {
    yield put(generateEmailTemplateAIErrorAction(e.message));
  }
}

// Email Template Watchers
export function* watchGetAllEmailTemplates() {
  yield takeLatest(DeploymentConst.GET_ALL_EMAIL_TEMPLATES, getAllEmailTemplatesHandler);
}

export function* watchCreateEmailTemplate() {
  yield takeLatest(DeploymentConst.CREATE_EMAIL_TEMPLATE, function* (action: any) {
    yield call(createEmailTemplateHandler, action.payload.template);
  });
}

export function* watchUpdateEmailTemplate() {
  yield takeLatest(DeploymentConst.UPDATE_EMAIL_TEMPLATE, function* (action: any) {
    yield call(updateEmailTemplateHandler, action.payload.template);
  });
}

export function* watchResetEmailTemplate() {
  yield takeLatest(DeploymentConst.RESET_EMAIL_TEMPLATE, function* (action: any) {
    yield call(resetEmailTemplateHandler, action.payload.template);
  });
}

function* setDefaultEmailTemplateHandler(template: any) {
  try {
    yield put(setDefaultEmailTemplateLoadingAction());
    const payload = { ...buildTemplatePayload(template, template.isLrTemplate), isDefault: true };
    const data = yield httpPut("/deployment/email-workflow", {}, payload);
    if (data.ErrorCode) {
      throw new Error(data.Message || data.Description);
    }
    yield put(setDefaultEmailTemplateSuccessAction({ ...data }));
    yield put(getAllEmailTemplatesAction());
  } catch (e) {
    yield put(setDefaultEmailTemplateErrorAction(e.message));
  }
}

export function* watchSetDefaultEmailTemplate() {
  yield takeLatest(DeploymentConst.SET_DEFAULT_EMAIL_TEMPLATE, function* (action: any) {
    yield call(setDefaultEmailTemplateHandler, action.payload.template);
  });
}

export function* watchDeleteEmailTemplate() {
  yield takeLatest(DeploymentConst.DELETE_EMAIL_TEMPLATE, function* (action: any) {
    yield call(deleteEmailTemplateHandler, action.payload.templateType, action.payload.templateName);
  });
}

export function* watchGetEmailSettings() {
  yield takeLatest(DeploymentConst.GET_EMAIL_SETTINGS, getEmailSettingsHandler);
}

export function* watchSaveEmailSettings() {
  yield takeLatest(DeploymentConst.SAVE_EMAIL_SETTINGS, function* (action: any) {
    yield call(saveEmailSettingsHandler, action.payload);
  });
}

// export function* watchSendTestEmail() {
//   yield takeLatest(DeploymentConst.SEND_TEST_EMAIL_TEMPLATE, function* (action: any) {
//     yield call(sendTestEmailHandler, action.payload.mailObject);
//   });
// }

export function* watchGenerateEmailTemplateAI() {
  yield takeLatest(DeploymentConst.GENERATE_EMAIL_TEMPLATE_AI, function* (action: any) {
    yield call(generateEmailTemplateAIHandler, action.payload);
  });
}

// export function* watchVerifySMTPSettings() {
//   while (true) {
//     const request = yield take(SMTPSettingsConst.VERIFY_SMTP_SETTINGS);
//     yield call(verifySMTPSettingsHandler, request.payload, request.i18n);
//   }
// }
